import { MutableRefObject, createContext } from 'react';

import { PageId } from '../../apis';

export interface CurrentPageView {
  pageId: PageId | null;
  pageViewId: string | null;
}

export interface PageTrackingContextValue {
  currentPageViewRef: MutableRefObject<CurrentPageView>;
  notifyPageTracked: () => void;
  setNotifier: (fn: (() => void) | null) => void;
}

const noop = () => {};

export const PageTrackingContext = createContext<PageTrackingContextValue>({
  currentPageViewRef: { current: { pageId: null, pageViewId: null } },
  notifyPageTracked: noop,
  setNotifier: noop,
});
